import { render, staticRenderFns } from "./FormDateField.vue?vue&type=template&id=b4032248&"
import script from "./FormDateField.vue?vue&type=script&lang=js&"
export * from "./FormDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports